import styled from 'styled-components';

export const StyledGuardianAddressFormContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 18px;
`;
StyledGuardianAddressFormContent.displayName = 'StyledGuardianAddressFormContent';
